import { Typography } from '@mui/material'
import { withStyles } from '@mui/styles'

const Title = (color: string) =>
  withStyles({
    root: { color }
  })(Typography)

export default Title
